const { Pagination, Mousewheel } = require("swiper/modules");
import { addToCart } from './services/cart-api';

document.addEventListener('DOMContentLoaded', function () {
    const isMobile = window.innerWidth <= 768;
    if ( isMobile ) {
        const atcFixedButton = document.querySelector('.product-page-template .fixed-atc');
        const atcRegularButton = document.querySelector('.template-product .product-form__item.product-form__item--submit');

        const manageATCFixedButtonVisibility = (atcFixedButton, atcRegularButton) => {
            const atcRegularButtonRect = atcRegularButton && atcRegularButton.getBoundingClientRect();
            const isATCRegularButtonVisible = atcRegularButtonRect.top > 0 && atcRegularButtonRect.top < 600;
            atcFixedButton.style.display = isATCRegularButtonVisible ? 'none' : '';
        };

        if (atcFixedButton && atcRegularButton) {
          manageATCFixedButtonVisibility(atcFixedButton, atcRegularButton);
          window.onscroll = () => manageATCFixedButtonVisibility(atcFixedButton, atcRegularButton);
        }
    }

  // PDP redesign
  initPDPRedesign();
});

const swiperRelatedProducts = new Swiper('.related-products__carousel',{
  slidesPerView: 4,
  loop: true,
  spaceBetween: 20,
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
  pagination: {
    el: '.swiper-pagination',
    clickable: true,
  },
  breakpoints: {
    320: {
      slidesPerView: 1,
    },
    576: {
      slidesPerView: 2,
    },
    768: {
      slidesPerView: 3,
    },
    992: {
      slidesPerView: 4,
    }
  }
})

// PDP redesign
function initPDPRedesign () {

  const isMobile = window.innerWidth <= 768;

    const atcStyledButtons = document.querySelectorAll('.main-product-container .styled-with-container__item--button');
    const colorSwatchesStyled = document.querySelectorAll('.main-product-container .styled-with-container label.ColorSwatch');
    const productsStyledIt = document.querySelectorAll('.main-product-container .styled-with-container .styled-with-container__item');
    const productColorNameLabel = document.querySelector('.main-product-container .product-form__item.color .option-name');
    const productColorsContainer = document.querySelector('.main-product-container .product-form__item.color .single-option-radio.color');
    const productSizesContainer = document.querySelector('.main-product-container .product-form__item.size .product-size-options .sizes-container');
    const ATCButton = document.querySelector('.main-product-container .product-form__cart-submit.main-atc-button');
    const paymentButtonWrapper = document.querySelector('.main-product-container .product-form__buynow');
    const mayLikeSizesButtons = document.querySelectorAll('.may-also-like-products-container .hover-buttons');

    // product thumbnails swiper — the thumbs rail stays visible on desktop (to the left of
    // the sticky gallery, see mn_product-gallery.js), the 768px breakpoint below switches it
    // from a horizontal mobile strip to a vertical desktop rail.
    let productThumbnailsSwiper = new Swiper('.main-product-container__image--thumbs-swiper', {
      slidesPerView: "auto",
      spaceBetween: 8,
      direction: "horizontal",
      loop: false,
      mousewheel: {
        forceToAxis: true,
      },
      breakpoints: {
        768: {
          slidesPerView: 6,
          slidesPerGroup: 6,
          direction: "vertical",
          mousewheel: {
            forceToAxis: true,
          },
        }
      }
    });
    goToActiveThumbnailSlide(productThumbnailsSwiper);


    // handle color option name to change the color label and the corresponding sizes
    if (productColorNameLabel && productColorsContainer) {
      handleColorOptionName(productColorNameLabel, productColorsContainer, productSizesContainer, productThumbnailsSwiper, ATCButton, paymentButtonWrapper);
    }

    // set sizes using the default color
    if (productColorsContainer && productSizesContainer) {
      setSizesByDefaultColor(productColorsContainer, productSizesContainer);
    }

    // a rendered sizes container only means the product *has* a Size option — products like
    // bags often carry a single trivial value (e.g. "One Size"), which isn't a real choice.
    // Only gate the buy buttons behind a size pick when there's actually more than one to pick.
    const requiresSizeSelection = !!(productSizesContainer && productSizesContainer.querySelectorAll('.size-swatch-label').length > 1);

    // disable "Buy with Shop" until a size is picked, matching the ATC button's disabled state
    if (requiresSizeSelection && paymentButtonWrapper) {
      paymentButtonWrapper.classList.add('is-disabled');
    }

    // the native variant select defaults to a pre-selected size even though nothing has
    // been picked yet; clear it so it doesn't visually contradict the swatches/buttons
    if (requiresSizeSelection) {
      const variantSelect = document.querySelector('.main-product-container select[name="id"]');
      if (variantSelect) {
        variantSelect.selectedIndex = -1;
      }
    }

    // set variant id on ATC button
    if (requiresSizeSelection && ATCButton) {
      handleSizeOptions(productSizesContainer, ATCButton, paymentButtonWrapper);
    } else if (ATCButton) {
      const selectedColorInput = productColorsContainer && productColorsContainer.querySelector('.content-variant-color input:checked');
      const selectedColorItem = selectedColorInput && selectedColorInput.closest('.content-variant-color');
      const variantID = (selectedColorItem && selectedColorItem.getAttribute('data-variant-id')) || ATCButton.getAttribute('data-variant-id');
      const isAvailable = selectedColorItem
        ? selectedColorItem.getAttribute('data-variant-status') !== 'false'
        : !ATCButton.classList.contains('btn--sold-out');

      setAtcButtonState(ATCButton, paymentButtonWrapper, {
        variantID,
        available: isAvailable,
        isPreOrder: false,
      });
    }

    // perform ATC action
    if (ATCButton) {
      handleProductATC(ATCButton);
    }

    handleAllDescriptionTabs();

    // styled-it color swatches slider
    let swatchesSwiper = new Swiper('.swiper-color-swatches', {
      slidesPerView: 9,
      slidesPerGroup: 9,
      spaceBetween: 10,
      slidesOffsetBefore: 2,
      // slidesOffsetAfter: 50,
      mousewheel: {
        forceToAxis: true,
      },
      navigation: {
        nextEl: '.swiper-button-next-color-swatches',
        prevEl: '.swiper-button-prev-color-swatches',
      },
    });

    // may-also-like slider
    let relatedProductsSwiper = new Swiper('.swiper-may-also-like-products', {
      slidesPerView: 2,
      slidesPerGroup: 2,
      mousewheel: {
        forceToAxis: true,
      },
      scrollbar: {
        dragSize: 50,
        el: '.swiper-scrollbar',
      },
      breakpoints: {
        426: {
          slidesPerGroup: 1,
        },
        950: {
          slidesPerView: 3,
          slidesPerGroup: 1,
        },
        1200: {
          slidesPerView: 4,
          slidesPerGroup: 4,
        }
      }
    });

    // handle sizes container on mobile you may also like section
    if (isMobile && mayLikeSizesButtons.length) {
      handleMayLikeSizesButtons(mayLikeSizesButtons);
    }

    // close the sizes container on add to card
    document.addEventListener('pdm-cart-toggle', async event => {
      const isCartOpenTriggered = event.detail.isCartOpen;
      if (isCartOpenTriggered) {
        const sizesContainer = document.querySelector('.sizes-container-fixed.mobile-only');
        if (sizesContainer) {
          sizesContainer.classList.add('product-hidden');
        }
      }
    });

    // styled with ATC
    if (atcStyledButtons.length) {
      atcStyledButtons.forEach(button => {
        button.addEventListener('click', e => handleAtcStyledButtonClick(e, button));
      });
    }

    // swatches events styled with section
    if (colorSwatchesStyled.length) {
      colorSwatchesStyled.forEach(swatch => {
        swatch.addEventListener('click', e => handleSwatchClick(e, swatch));
      });
    }

    // set color name when page loads on styled-it-with section
    if (productsStyledIt.length) {
      productsStyledIt.forEach(product => {
        const firstColorSwatch = product.querySelector('.colors-container .ColorSwatch:first-child');
        const colorLabelContainer = product.querySelector('.product-color-swatches__label-container');
        const colorNameContainer = product.querySelector('.product-color-swatches__selected-color-label');

        if (firstColorSwatch) {
          const selectedColorName = firstColorSwatch.getAttribute('data-tooltip');
          if (colorNameContainer && selectedColorName) {
            colorNameContainer.textContent = selectedColorName;
          }
        } else {
          if (colorLabelContainer) {
            colorLabelContainer.style.display = 'none';
          }
        }
      });
    }

    // frequently bought together section
    handleFrequentlyBoughtTogetherSection();

    // handle click outside of the sizes container
    document.addEventListener('click', e => {
      const sizesContainer = document.querySelector('.sizes-container-fixed.mobile-only');
      const body = document.querySelector('body');
      if (sizesContainer && !sizesContainer.contains(e.target)) {
        sizesContainer.classList.add('product-hidden');
        body.classList.remove('overlay');
      }
    });

}

/**
 * Hides size swatch labels that don't match the default (first) color.
 * Retrieves the default color from the first .content-variant-color element in productColorsContainer,
 * then iterates through each .size-swatch-label in productSizesContainer to add a hidden class when mismatched.
 */
function setSizesByDefaultColor (productColorsContainer, productSizesContainer) {
  const firstColorItem = productColorsContainer.querySelector('.content-variant-color:first-child');
  const colorNameDefault = firstColorItem && firstColorItem.getAttribute('data-color');
  const sizeItems = productSizesContainer.querySelectorAll('.size-swatch-label');

  if (sizeItems.length) {
    sizeItems.forEach(sizeItem => {
      const sizeItemColor = sizeItem.getAttribute('data-color');

      if (colorNameDefault !== sizeItemColor) {
        sizeItem.classList.add('size-option-hidden');
      }
    });
  }
}

/**
 * Syncs the native `select[name="id"]` in the product form with the given variant ID
 * and fires a `change` event so Shopify's own scripts (e.g. the "Buy with Shop" dynamic
 * checkout button) pick up the newly selected variant. The custom size/color swatches
 * never touch this native select on their own, so without this the payment button stays
 * pinned to whichever variant was rendered server-side by default.
 */
function syncNativeVariantSelect(variantID) {
  const variantSelect = document.querySelector('.main-product-container select[name="id"]');

  if (variantSelect && variantID) {
    variantSelect.value = variantID;
    variantSelect.dispatchEvent(new Event('change', { bubbles: true }));
  }
}

function isVariantPurchasable(variantId) {
  if (!variantId) {
    return false;
  }

  const sizeRadio = document.querySelector(`.main-product-container .size-swatch-radio[data-variant-id="${variantId}"]`);
  if (sizeRadio) {
    if (sizeRadio.getAttribute('data-pre-order') === 'true') {
      return true;
    }
    return !sizeRadio.disabled && !sizeRadio.classList.contains('disabled');
  }

  const colorItem = document.querySelector(`.main-product-container .content-variant-color[data-variant-id="${variantId}"]`);
  if (colorItem) {
    return colorItem.getAttribute('data-variant-status') !== 'false';
  }

  return true;
}

function getWaitlistDetails(variantID) {
  const sizeRadio = variantID
    ? document.querySelector(`.main-product-container .size-swatch-radio[data-variant-id="${variantID}"]`)
    : null;
  const colorItem = variantID
    ? document.querySelector(`.main-product-container .content-variant-color[data-variant-id="${variantID}"]`)
    : null;
  const colorLabel = document.querySelector('.main-product-container .product-form__item.color .option-name');
  const sizeLabel = sizeRadio && sizeRadio.closest('.size-swatch-label')
    ? sizeRadio.closest('.size-swatch-label').querySelector('.customize-label')
    : null;
  const colorInput = colorItem && colorItem.querySelector('input');

  return {
    size: (sizeLabel && sizeLabel.textContent.trim())
      || (sizeRadio && (sizeRadio.getAttribute('data-size') || sizeRadio.value))
      || '',
    color: (sizeRadio && sizeRadio.getAttribute('data-color-name'))
      || (colorInput && colorInput.value)
      || (colorLabel && colorLabel.textContent.trim())
      || '',
  };
}

function updateWaitlist({ available, variantID } = {}) {
  const waitlist = document.querySelector('.js-contact-soldout');
  if (!waitlist) {
    return;
  }

  waitlist.querySelectorAll('.form-success').forEach(el => el.remove());

  if (available) {
    waitlist.classList.add('hide');
    return;
  }

  const { size, color } = getWaitlistDetails(variantID);
  const productTitle = waitlist.getAttribute('data-product-title') || '';
  const productUrl = waitlist.getAttribute('data-product-url') || '';
  const summary = [productTitle, [color, size].filter(Boolean).join(' / ')].filter(Boolean).join(' - ');
  const bodyLines = [`Waitlist request`, `Product: ${productTitle}`];
  if (color) {
    bodyLines.push(`Color: ${color}`);
  }
  if (size) {
    bodyLines.push(`Size: ${size}`);
  }
  if (productUrl) {
    bodyLines.push(productUrl);
  }

  const notifyText = document.querySelector('.js-notify-text span');
  const productField = document.getElementById('ContactProduct');
  const colorField = document.getElementById('ContactColor');
  const sizeField = document.getElementById('ContactSize');
  const bodyField = document.getElementById('ContactBody');

  if (notifyText) {
    notifyText.textContent = summary;
  }
  if (productField) {
    productField.value = productTitle;
  }
  if (colorField) {
    colorField.value = color;
  }
  if (sizeField) {
    sizeField.value = size;
  }
  if (bodyField) {
    bodyField.value = bodyLines.join('\n');
  }

  waitlist.classList.remove('hide');
}

function setAtcButtonState(ATCButton, paymentButtonWrapper, { variantID, available, isPreOrder }) {
  if (!ATCButton) {
    return;
  }

  if (variantID) {
    ATCButton.setAttribute('data-variant-id', variantID);
  }

  if (isPreOrder || available) {
    ATCButton.removeAttribute('disabled');
    ATCButton.classList.remove('btn--sold-out');
    ATCButton.textContent = isPreOrder
      ? ATCButton.getAttribute('data-atc-label-pre-order')
      : ATCButton.getAttribute('data-atc-label');
    if (paymentButtonWrapper) {
      paymentButtonWrapper.classList.remove('is-disabled');
    }
    updateWaitlist({ available: true, variantID });
    return;
  }

  ATCButton.setAttribute('disabled', 'disabled');
  ATCButton.classList.add('btn--sold-out');
  ATCButton.textContent = ATCButton.getAttribute('data-atc-label-sold-out') || 'Sold Out';
  if (paymentButtonWrapper) {
    paymentButtonWrapper.classList.add('is-disabled');
  }
  updateWaitlist({ available: false, variantID });
}

/**
 * Updates the selected size option and sets the matching variant ID on each ATC button.
 * Ensures only one size option is marked as selected at a time.
 * Propagates the variant ID from the clicked size option to the ATC buttons.
 */
function handleSizeOptions(productSizesContainer, ATCButton, paymentButtonWrapper) {
  const sizeOptions = productSizesContainer.querySelectorAll('.size-swatch-label');

  if (sizeOptions.length) {
    sizeOptions.forEach(sizeOption => {
      sizeOption.addEventListener('click', e => {
        e.preventDefault();

        const variantRadio = sizeOption.querySelector('.size-swatch-radio');
        const isPreOrder = variantRadio?.getAttribute('data-pre-order') === 'true';
        const isSoldOut = !isPreOrder && (
          sizeOption.classList.contains('disabled')
          || variantRadio?.classList.contains('disabled')
          || variantRadio?.disabled
        );

        sizeOptions.forEach(size => size.classList.remove('selected'));
        sizeOption.classList.add('selected');

        const variantID = variantRadio?.getAttribute('data-variant-id');

        setAtcButtonState(ATCButton, paymentButtonWrapper, {
          variantID,
          available: !isSoldOut,
          isPreOrder,
        });

        if (!isSoldOut) {
          syncNativeVariantSelect(variantID);
        }
      });
    });
  }
}

/**
 * Attaches a click event listener to each Add-to-Cart button.
 * When clicked, it prevents default behavior and stops propagation, then retrieves
 * the variant ID from the button's data attribute and adds that variant to the cart.
 * On a successful add-to-cart response, the mini-cart is refreshed.
 *
 * @param ATCButton - An Add-to-Cart button.
 */
function handleProductATC(ATCButton) {
  if (ATCButton) {
    ATCButton.addEventListener('click', async e =>  {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();

      if (ATCButton.disabled || ATCButton.classList.contains('btn--sold-out')) {
        return;
      }

      const variantID = ATCButton.getAttribute('data-variant-id');
      if (!isVariantPurchasable(variantID)) {
        return;
      }

      const addToCartResponse = await addToCart(variantID, 1);

      if (addToCartResponse.status) {
        theme.miniCart.generateCart();
        theme.miniCart.updateElements();
        const addToCartEvent = new CustomEvent('pdm-add-to-cart', {
          detail: { items: 'sended', data: addToCartResponse.response || addToCartResponse }
        });
        document.dispatchEvent(addToCartEvent);
      }
    });
  }
}

/**
 * Updates the color name label and filters size options based on the selected color.
 * Sets the default label from the first color and updates on click.
 * Hides sizes that don't match the selected color.
 */
function handleColorOptionName(productColorNameLabel, productColorsContainer, productSizesContainer, productThumbnailsSwiper, ATCButton, paymentButtonWrapper) {
  const colorItems = productColorsContainer.querySelectorAll('.content-variant-color.content-color');
  const sizeItems = productSizesContainer && productSizesContainer.querySelectorAll('.size-swatch-label');

  if (colorItems.length) {
    colorItems.forEach((colorItem, index) => {
      if (index === 0) {
        const colorName = colorItem.querySelector('.customize_color').getAttribute('data-original-title');
        productColorNameLabel.textContent = colorName;
      }

      // change the color name on click
      colorItem.addEventListener('click', ()=>{
        const colorName = colorItem.querySelector('.customize_color').getAttribute('data-original-title');
        const selectedColorForSize = colorItem.getAttribute('data-color');

        // set the new name
        if (colorName) {
          productColorNameLabel.textContent = colorName;
        }

        // change the sizes
        if (sizeItems && sizeItems.length) {
          if (selectedColorForSize) {
            sizeItems.forEach(sizeItem => sizeItem.classList.remove('size-option-hidden'));

            sizeItems.forEach(sizeItem => {
              const sizeItemColor = sizeItem.getAttribute('data-color');

              if (sizeItemColor && selectedColorForSize !== sizeItemColor) {
                sizeItem.classList.add('size-option-hidden');
              }
            });
          }

          // a size choice still has to be (re)made for the new color, so re-lock the ATC
          // button until handleSizeOptions' click handler re-enables it
          if (ATCButton) {
            ATCButton.setAttribute('disabled', 'disabled');
            ATCButton.classList.remove('btn--sold-out');
            ATCButton.textContent = ATCButton.getAttribute('data-atc-label-disabled');
          }
          if (paymentButtonWrapper) {
            paymentButtonWrapper.classList.add('is-disabled');
          }
          updateWaitlist({ available: true });
        } else {
          const variantID = colorItem?.getAttribute('data-variant-id');
          const available = colorItem?.getAttribute('data-variant-status') !== 'false';

          setAtcButtonState(ATCButton, paymentButtonWrapper, {
            variantID,
            available,
            isPreOrder: false,
          });

          if (available) {
            syncNativeVariantSelect(variantID);
          }
        }

        // move thumbnails slider to the active one
        setTimeout(()=>{
          goToActiveThumbnailSlide(productThumbnailsSwiper);
        },500);
      });
    });
  }
}

/**
 * Opens and closes each product accordion from its title row, including the plus/minus icons.
 */
function handleAllDescriptionTabs() {
  const containers = document.querySelectorAll('.description-product-container');

  containers.forEach(container => {
    const title = container.querySelector('.description-product-container__title');
    const content = container.querySelector('.description-product-container__content');
    const icons = container.querySelectorAll('.description-product-container__icons svg');

    if (!title || !content || icons.length < 2) return;

    const plusIcon = icons[0];
    const minusIcon = icons[1];

    title.setAttribute('role', 'button');
    title.setAttribute('tabindex', '0');
    title.setAttribute('aria-expanded', content.classList.contains('product-hidden') ? 'false' : 'true');

    const toggle = () => {
      const open = content.classList.contains('product-hidden');
      content.classList.toggle('product-hidden');
      plusIcon.classList.toggle('product-hidden', open);
      minusIcon.classList.toggle('product-hidden', !open);
      title.setAttribute('aria-expanded', open ? 'true' : 'false');
    };

    title.addEventListener('click', toggle);
    title.addEventListener('keydown', (event) => {
      if (event.key !== 'Enter' && event.key !== ' ') return;
      event.preventDefault();
      toggle();
    });
  });
}



/**
 * Handles a styled ATC button click: prevents default action, retrieves the selected variant ID, adds it to the cart, and updates the miniCart on success.
 */
async function handleAtcStyledButtonClick(e, atcButton) {
  e.preventDefault();

  if (atcButton.disabled) {
    return;
  }

  const selectedVariantId = atcButton.getAttribute('data-variant-id');
  const productContainer = atcButton.closest('.styled-with-container__item');
  const selectedSwatch = productContainer?.querySelector('.ColorSwatch.selected');
  if (selectedSwatch && selectedSwatch.getAttribute('data-variant-status') === 'false') {
    return;
  }

  if (selectedVariantId) {
    let addToCartResponse = await addToCart(selectedVariantId, 1);

    if (addToCartResponse.status) {
      theme.miniCart.generateCart();
      theme.miniCart.updateElements();
      const addToCartEvent = new CustomEvent('pdm-add-to-cart', {
        detail: { items: 'sended', data: addToCartResponse.response || addToCartResponse }
      });
      document.dispatchEvent(addToCartEvent);
    }
  }
}

/**
 * Handles swatch clicks: prevents default action, toggles the "selected" state,
 * updates the ATC button's variant ID, and sets the displayed color name.
 */
function handleSwatchClick (e, swatch) {
  e.preventDefault();

  const productContainer = swatch.closest('.styled-with-container__item');
  const productColorSwatches = productContainer.querySelectorAll('.ColorSwatch');
  if (swatch.getAttribute('data-variant-status') === 'false') {
    return;
  }

  const swatchRadio = swatch.querySelector('.ColorSwatch__Radio');
  const atcButton = productContainer.querySelector('.styled-with-container__item--button');
  const colorNameContainer = productContainer.querySelector('.product-color-swatches__selected-color-label');
  const variantImageUrl = swatch.getAttribute('data-variant-image-url');
  const mainImageSection = productContainer.querySelector('.styled-with-container__item--image-img');

  // handle selected class
  if (productColorSwatches.length) {
    productColorSwatches.forEach(swatch => {
      swatch.classList.remove('selected');
    });
  }
  swatch.classList.add('selected');

  // set variant ID
  const selectedVariantId = swatch.getAttribute('data-variant-id');
  if (atcButton && selectedVariantId) {
    atcButton.setAttribute('data-variant-id', selectedVariantId);
  }

  // set color name
  const selectedColorName = swatch.getAttribute('data-tooltip');
  if (colorNameContainer && selectedColorName) {
    colorNameContainer.textContent = selectedColorName;
  }

  // set variant image
  if (mainImageSection && variantImageUrl) {
    mainImageSection.setAttribute('src', variantImageUrl);
  }

  updateStyledWithPrice(productContainer, selectedVariantId);
}

function updateStyledWithPrice(productContainer, variantId) {
  const priceEl = productContainer.querySelector('.styled-with-container__item--description-price');
  const productId = productContainer.getAttribute('data-product-id');
  const productData = window.listProducts && window.listProducts[productId];
  if (!priceEl || !productData || !productData.variants) return;
  const variant = productData.variants.find(item => String(item.id) === String(variantId));
  if (!variant) return;
  if (window.theme && typeof theme.formatCatalogDiscountHtml === 'function') {
    const compare = variant.compare_at_price > variant.price ? variant.compare_at_price : 0;
    priceEl.innerHTML = theme.formatCatalogDiscountHtml(variant.price, compare);
  }
}

function formatFbtTotalHtml(cents) {
  if (window.theme && typeof theme.formatCatalogDiscountHtml === 'function') {
    return theme.formatCatalogDiscountHtml(cents, 0);
  }
  return '$' + (cents / 100).toFixed(2);
}

/**
 * Manages the Frequently Bought Together section by toggling product images and updating total price
 * based on selected variant checkboxes, adapting the UI for mobile/desktop, and handling add-to-cart actions.
 */
function handleFrequentlyBoughtTogetherSection() {
  const fbtTotalEls = document.querySelectorAll('.freq-bought-together-wrapper .fbt__total');
  const fbtImgContainers = Array.from(document.querySelectorAll('.freq-bought-together-wrapper .fbt__img-container'));
  const fbtAtcButtons = document.querySelectorAll('.freq-bought-together-wrapper .fbt__atc, .fbt__atc-mobile');
  const plusTwo = document.getElementById('fbt-plus-two');
  const fbtDesktopOnly = document.querySelectorAll('.freq-bought-together-wrapper .desktop-only');
  const fbtMobileOnly = document.querySelectorAll('.freq-bought-together-wrapper .mobile-only');
  const isMobile = window.innerWidth <= 768;
  const checkboxes = document.querySelectorAll(`.freq-bought-together-wrapper input[type=checkbox]${isMobile ? '.mobile-only' : '.desktop-only'}`);

  if (isMobile) {
    if (fbtDesktopOnly.length) {
      fbtDesktopOnly.forEach(element => element.remove());
    }
  } else {
    if (fbtMobileOnly.length) {
      fbtMobileOnly.forEach(element => element.remove());
    }
  }

  // Array to hold the selected variant IDs
  let selectedVariantIds = [];

  // Update the total price display
  function updateTotal() {
    const total = calculateCheckedFbtTotal();

    fbtTotalEls.forEach(el => {
      el.innerHTML = formatFbtTotalHtml(total);
    });
  }

  // Calculate total from checked checkboxes using their data-price values
  function calculateCheckedFbtTotal() {
    let total = 0;
    checkboxes.forEach(box => {
      if (box.checked) {
        total += Number(box.dataset.price);
      }
    });
    return total;
  }

  // Manage the visibility of images and update the selected variant IDs
  function manageFBT(isChecked, variantId) {
    fbtImgContainers.forEach((item, index) => {
      if (item.dataset.variantid === variantId) {
        if (isChecked) {
          item.style.display = 'block';
          if (!selectedVariantIds.includes(variantId)) {
            selectedVariantIds.push(variantId);
          }
          handlePlus(index, 'add');
        } else {
          item.style.display = 'none';
          selectedVariantIds = selectedVariantIds.filter(id => id !== variantId);
          handlePlus(index, 'remove');
        }
      }
    });
    updateTotal();
  }

  // Toggle plus indicator visibility based on the number of selected variants
  function handlePlus(index, type) {
    if (selectedVariantIds.length < 2) {
      if (plusTwo) plusTwo.style.display = 'none';
    } else {
      if (plusTwo) plusTwo.style.display = 'block';
    }
  }

  // Set up checkbox event listeners
  checkboxes.forEach(checkbox => {
    checkbox.addEventListener('change', event => {
      manageFBT(event.target.checked, event.target.dataset.variantid);
    });
  });

  // Initialize in case some checkboxes are pre-checked
  checkboxes.forEach(checkbox => {
    manageFBT(checkbox.checked, checkbox.dataset.variantid);
  });

  // Set up Add-to-Cart button listeners
  if (fbtAtcButtons.length) {
    fbtAtcButtons.forEach(button => {
      button.addEventListener('click', async () => {
        let addToCartResponse = await addToCart(selectedVariantIds, 1);

        if (addToCartResponse.status) {
          theme.miniCart.generateCart();
          theme.miniCart.updateElements();
          const addToCartEvent = new CustomEvent('pdm-add-to-cart', {
            detail: { items: 'sended', data: addToCartResponse.response || addToCartResponse }
          });
          document.dispatchEvent(addToCartEvent);
        }
      });
    });
  }

  // Initial total update
  updateTotal();
}

/**
 * Attaches click handlers to "May Also Like" size buttons that clone and display the hidden sizes container,
 * while preventing default actions and hiding the original element.
 */
function handleMayLikeSizesButtons(mayLikeSizesButtons) {
  mayLikeSizesButtons.forEach(mayLikeSizesButton => {
    mayLikeSizesButton.addEventListener('click', e => {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();

      const containerToShowSizes = mayLikeSizesButton.closest('.may-also-like-products-container').querySelector('.sizes-container-fixed');
      const sizesContainer = mayLikeSizesButton.closest('.custom-collection-grid__item-link').querySelector('.product-in-collection__sizes');

      if (containerToShowSizes && sizesContainer) {
        containerToShowSizes.classList.remove('product-hidden');
        containerToShowSizes.innerHTML = "";
        sizesContainer.removeAttribute('style');
        containerToShowSizes.appendChild(sizesContainer.cloneNode(true));
        sizesContainer.setAttribute('style', 'display: none !important;');
      }
    });
  });
}

/**
 * Navigates the given productThumbnailsSwiper to the slide marked as active (using its data-swiper-slide-index).
 * If no active slide or valid index is found, it does nothing.
 */
function goToActiveThumbnailSlide(productThumbnailsSwiper) {
  if (!productThumbnailsSwiper) {
    return;
  }

  const activeSlide = document.querySelector(
    '.main-product-container__image--thumbs .product-single__thumbnail-item.is-active'
  );

  if (activeSlide) {
    productThumbnailsSwiper.update();
    productThumbnailsSwiper.updateSize();

    const indexPosition = parseInt(activeSlide.getAttribute('aria-label').split('/')[0], 10) - 1;
    if (!isNaN(indexPosition)) {
      productThumbnailsSwiper.slideTo(indexPosition, 300);
    }
  }
}
